import { lazy } from 'react';

export const CHUNK_RELOAD_FLAG = 'beagly-chunk-reload';

const RETRY_DELAY_MS = 1500;

const delay = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const safeStorage = (operation, fallback) => {
  try {
    return operation();
  } catch (error) {
    return fallback;
  }
};

export const readChunkReloadFlag = () =>
  safeStorage(() => Boolean(sessionStorage.getItem(CHUNK_RELOAD_FLAG)), true);

export const writeChunkReloadFlag = () =>
  safeStorage(() => sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1'), undefined);

export const clearChunkReloadFlag = () =>
  safeStorage(() => sessionStorage.removeItem(CHUNK_RELOAD_FLAG), undefined);

export const importWithRetry = (importFn) =>
  importFn()
    .catch(() => delay(RETRY_DELAY_MS).then(importFn))
    .then((module) => {
      clearChunkReloadFlag();
      return module;
    });

export default function lazyWithRetry(importFn) {
  return lazy(() => importWithRetry(importFn));
}
